import { render, staticRenderFns } from "./AlignTopIcon.vue?vue&type=template&id=cdebf2da&"
import script from "./AlignTopIcon.vue?vue&type=script&lang=js&"
export * from "./AlignTopIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports